import { z } from "zod";

export const humanCapitalSkillsSchema = z.object({
    mainExpertise: z.string(),
    industryExperience: z.array(z.string()),
    topSkills: z.array(z.string()),
});

export type HumanCapitalSkills = z.infer<typeof humanCapitalSkillsSchema>;
